// removed by extract-text-webpack-plugin
module.exports = {"portfolio-view":"_1LNNf0W1","portfolioView":"_1LNNf0W1","project-list":"_16vHSn7g","projectList":"_16vHSn7g","project-details":"_2BC-TP3n","projectDetails":"_2BC-TP3n"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PortfolioView/PortfolioView.pcss
// module id = 838
// module chunks = 0